<div *ngIf="isEditable">
	<div *ngIf="options.tabSectionMode === tabSectionMode.DROPDOWN">
		<cv-dropdown-button
			#dropdownButton
			[label]="buttonLabel"
			[icon]="'fa-plus'"
			[position]="'down'"
			[buttonClass]="'btn-sm cv-btn-light'"
			[items]="dropdownOptions"
			(subOptionClick)="onExecuteAction($event)">
		</cv-dropdown-button>
	</div>
</div>
